import Vue from 'vue'
import Vuex from 'vuex'
import cobro from './modules/cobro'
import formas from './modules/formas'
import reportes from './modules/reportes'
import login from './modules/login'
import padrones from './modules/padrones'
import contribuyente from './modules/contribuyente'
import admin from './modules/admin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    cobro,
    formas,
    reportes,
    login,
    padrones,
    contribuyente,
    admin
  }
})